import { KeyValue } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  label?: string;
  options: KeyValue<string, string>[];
  selectedOption: KeyValue<string, string>;
}

@Component({
  templateUrl: './choose-option.dialog.html',
  styleUrls: ['./choose-option.dialog.scss'],
})
export class ChooseOptionDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    if(this.data.options?.length === 1) {
      this.data.selectedOption = this.data.options[0];
    }
  }

  compareFn(o1: any, o2: any): boolean {
    return o1 && o2 && o1.key === o2.key;
  }

}